import React from 'react'
import { presenceErrorClass } from 'servos/formValidations'

class InputWithAppend extends React.Component {
  onChange = (e) => {
    this.props.onChange(e.currentTarget.value)
  }

  render() {
    const {
      append,
      defaultValue,
      appendText,
      size,
      placeholder,
      errorMessage,
    } = this.props

    return(
      <div className={`input-group ${classes.input[append]}`}>
        <input
          value={defaultValue}
          className={ `form-control ${classes.control[size]} ${presenceErrorClass(errorMessage)}` }
          onChange={ this.onChange }
          placeholder={ placeholder || '' }
        />
        <div className='input-group-append'>
          <div className='input-group-text' style={{color: '#495057'}}>
            {appendText}
          </div>
        </div>
        {this.props.children}
        <div className="invalid-feedback">
          { errorMessage }
        </div>
      </div>
    )
  }
}

const classes = {
  control: {
    large: 'form-control-lg',
    withSelect: 'form-control col-6 aria-label',
  },
  input: {
    helptext: 'input-group-append-helptext'
  }
}

export default InputWithAppend;
